import { apiClient } from '@/shared/api'

import { TRoomRecommendSearchKeyword } from '../model/schema'

const CACHE_TIME = 60 * 60 * 24 * 1 // 1 day

export const getRoomRecommendSearchKeywords = async () => {
  const { data } = await apiClient.get<TRoomRecommendSearchKeyword>({
    endpoint: `/rooms/recommend/search-keywords`,
    option: {
      revalidate: CACHE_TIME,
    },
  })

  return data
}
